import { render, staticRenderFns } from "./ViewIPSetList.vue?vue&type=template&id=a4973262&scoped=true&"
import script from "./ViewIPSetList.vue?vue&type=script&lang=ts&"
export * from "./ViewIPSetList.vue?vue&type=script&lang=ts&"
import style0 from "./ViewIPSetList.vue?vue&type=style&index=0&id=a4973262&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4973262",
  null
  
)

export default component.exports